__turbopack_context__.v({
  "box": "nvvL3a_box",
});
